import { useCallback, useMemo, useState } from 'react';
import { I_Tenant } from '../types';
import { BaseXHR } from '@utils/axios';
import { TENANT_DEFAULT } from '../constants';
import { isServer } from '@utils/helper';

interface Props {
  host?: string;
}

export const useGetTenant = ({ host }: Props) => {
  const [tenant, setTenant] = useState<I_Tenant | undefined>(undefined);

  const onGetTenantByDomain = useCallback(async () => {
    try {
      const { data } = await BaseXHR.$get('/tenant/get-by-project', {
        id: host || (isServer ? '' : window.location.host),
      });
      setTenant({ ...TENANT_DEFAULT, ...data.data });
    } catch (err) {
      setTenant(TENANT_DEFAULT);
    }
  }, [host]);

  return useMemo(
    () => ({
      tenant,
      onGetTenantByDomain,
    }),
    [onGetTenantByDomain, tenant],
  );
};
